import EOrderingLogo from "@assets/images/eOrdering.png";
import SCGP_Color from "@assets/images/SCGP-color.svg";
import { OrderProcessingParams } from "@saleor/changeOrderExport/urls";
import HeadColored from "@saleor/components/HeadColored";
import MyTypography from "@saleor/components/MyTypography";
import SubmitOrder from "@saleor/createOrder/components/SubmitOrder";
import useNavigator from "@saleor/hooks/useNavigator";
import { makeStyles } from "@saleor/macaw-ui";
import React, { FC, useEffect } from "react";

const useStyle = makeStyles(
  () => ({
    root: {
      width: "100%",
      height: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    },
    mainPanel: {
      background: "transparent"
    },
    headTextLogo: {
      margin: "120px 0",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      transition: "all 0.5s ease"
    },
    text: {
      color: "#E41B17",
      fontWeight: "bold",
      fontSize: 30,
      padding: "5px 15px",
      borderRight: "solid 1px #E41B17"
    },
    logo: {
      marginLeft: 20
    },
    footer: {
      position: "absolute",
      bottom: "2.4rem",
      textAlign: "center",
      width: "100%"
    }
  }),
  { name: "OrderProcessing" }
);

interface OrderProcessingViewProps {
  params?: OrderProcessingParams;
}

const timeToCallBack = 5000;
const OrderProcessingView: FC<OrderProcessingViewProps> = ({ params }) => {
  const classes = useStyle();
  const navigate = useNavigator();

  useEffect(() => {
    if (params?.callback) {
      const { callback } = params;
      setTimeout(() => {
        navigate(callback);
      }, timeToCallBack);
    }
  }, []);

  return (
    <>
      <HeadColored fixedTop />
      <div className={classes.root}>
        <div className={classes.mainPanel}>
          <div className={classes.headTextLogo}>
            <div className={classes.text}>
              <img src={SCGP_Color} alt={"logo_scg"} />
            </div>
            <div className={classes.logo}>
              <img src={EOrderingLogo} alt={"logo"} />
            </div>
          </div>
          <SubmitOrder />
        </div>
      </div>
      <footer className={classes.footer}>
        <MyTypography variant="body3" style={{ color: "#333333" }}>
          COPYRIGHT 2022 SCG PACKAGING. ALL RIGHTS RESERVED.
        </MyTypography>
      </footer>
    </>
  );
};

export default OrderProcessingView;
